import React from "react";

const FieldErrorMsg = ({ containerClass = "", formik, id }) => {
  if (formik && formik.touched?.[id] && formik.errors?.[id]) {
    return (
      <span
        className={`text-red-500 text-sm mt-1 field-error-msg absolute -bottom-[40px] min-h-[40px] pl-1 ${containerClass}`}
      >
        {Array?.isArray(formik.errors?.[id])
          ? formik?.errors?.[id]?.filter((item) => item?.length)?.[0]
          : formik?.errors?.[id]}
      </span>
    );
  } else return null;
};

export default FieldErrorMsg;
